import React from 'react';
import CustomLink from '../CustomLink/CustomLink';
import { useAuthState } from 'react-firebase-hooks/auth';
import auth from '../firebase.init';
import { signOut } from 'firebase/auth';

const Header = () => {
    const [user] = useAuthState(auth);
    const handleSignOut = () => {
        signOut(auth);
    }
    return (
        <div>
            <nav class="navbar navbar-expand-lg navbar-light bg-success">
                <div class="container">
                    <a class="navbar-brand text-white" href="#">Laptop Bazar</a>
                    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                        <span class="navbar-toggler-icon"></span>
                    </button>
                    <div class="collapse navbar-collapse" id="navbarSupportedContent">
                        <ul class="navbar-nav me-auto mb-2 mb-lg-0">

                            <CustomLink to={'/'}>
                                <button className='btn btn-success p-2'>Home</button>
                            </CustomLink>

                            <CustomLink to={'/manageinvemtory'}>
                                <button className='btn btn-success p-2'>Manage Inventory</button>
                            </CustomLink>

                            <CustomLink to={'/blog'}>
                                <button className='btn btn-success p-2'>Blogs</button>
                            </CustomLink>

                            {
                                user ?
                                    <>    <CustomLink to={'/additem'}>
                                        <button className='btn btn-success p-2'>Add Item</button>
                                    </CustomLink>
                                        <CustomLink to={'/myitem'}>
                                            <button className='btn btn-success p-2'>My Item</button>
                                        </CustomLink>
                                        <button className='btn btn-success' onClick={handleSignOut}>logout</button></> : <CustomLink to={'/login'}>
                                        <button className='btn btn-success p-2'>Login</button>
                                    </CustomLink>
                            }

                        </ul>

                    </div>
                </div>
            </nav >
        </div >
    );
};

export default Header;